import NAME from "./constants";

export const GET_GENERAL_SETTINGS_ROWS = NAME + "/GET_GENERAL_SETTINGS_ROWS";
export const GET_GENERAL_SETTINGS_ROWS_FULFILLED = NAME + "/GET_GENERAL_SETTINGS_ROWS_FULFILLED";
export const GET_GENERAL_SETTINGS_ROWS_REJECTED = NAME + "/GET_GENERAL_SETTINGS_ROWS_REJECTED";